module.exports = __webpack_public_path__ + "img/717-ff8432.png";